import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projectsDb } from '../../lib/db/index.js';
import { Spinner } from '../shared/Spinner.js';
import { EmptyState } from '../shared/EmptyState.js';
import type { Project } from '../../types/project.js';

interface Props {
  uid: string;
}

/**
 * MyPage の「自分のプロジェクト」タブ。owner として作成した全 project（private 含む）を新着順表示。
 * ProjectsPage の ProjectCard とは別形式（情報密度を上げて行表示）。
 */
export function MyProjects({ uid }: Props) {
  const q = useQuery({
    queryKey: ['projects', 'mine', uid],
    queryFn: () => projectsDb.findByOwner(uid),
    enabled: !!uid,
  });

  if (q.isPending) return <Spinner />;
  const items = q.data ?? [];
  if (items.length === 0) {
    return <EmptyState title="トピックはまだありません" />;
  }
  return (
    <div style={{ borderTop: '1px solid var(--line)' }}>
      {items.map((p) => (
        <MyProjectRow key={p.id} project={p} />
      ))}
    </div>
  );
}

function MyProjectRow({ project }: { project: Project }) {
  const nav = useNavigate();
  return (
    <div className="me-row" onClick={() => nav(`/projects/${project.id}`)} style={{ cursor: 'pointer' }}>
      <div
        className="me-row-icon"
        style={{
          background: project.color,
          color: '#fff',
          fontSize: 10,
          fontFamily: 'var(--font-display)',
          fontWeight: 600,
        }}
      >
        PRJ
      </div>
      <div style={{ minWidth: 0 }}>
        <div className="me-row-title">{project.name}</div>
        <div className="me-row-meta">
          <span className="vis-badge" data-vis={project.visibility}>
            {project.visibility === 'shared' ? '共有中' : '非公開'}
          </span>
          <span className="badge" data-status={project.status}>
            <span className="badge-dot" />
            {project.status}
          </span>
          {project.description && (
            <span style={{ color: 'var(--ink-3)' }}>· {project.description.slice(0, 60)}</span>
          )}
        </div>
      </div>
    </div>
  );
}
